<script setup>
import { computed } from 'vue'
import { getOptionValue, getOptionLabel } from '../../../../../Utils/selectOptionUtils'

const props = defineProps({
  data: { type: [Object, String, Number], required: true },
  valueProperty: { type: String, default: 'id' },
  labelProperty: { type: String, default: 'name' },
  selected: { type: Boolean, default: false },
})

const value = computed(() => getOptionValue(props.data, props.valueProperty))
const label = computed(() => getOptionLabel(props.data, props.labelProperty))
</script>

<template>
  <option
    :key="value"
    :value="value"
    :data-icon="data?.params?.icon"
    :data-color="data?.params?.style?.color"
    :e2e-option="value"
    :selected="selected"
  >
    {{ $te(label) ? $t(label) : label }}
  </option>
</template>
